/*
 * Created on Mon Dec 27 2021
 *
 * Copyright (c) 2021 Cohart Inc - All Rights Reserved
 * Unauthorized copying of this file via any medium is strictly prohibited
 * Proprietary and confidential
 * Copyright terms written by Cohart Inc <support@cohart.co>, Mon Dec 27 2021
 */

export enum UserTitleStamp {
  'PARTNER ORGANIZATON' = 1,
  'VERIFIED USER' = 2,
  'EARLY ADOPTER' = 3,
  'COHART-ER' = 4,
  'ADVISOR' = 5,
  'COCOISTA' = 6,
}

export enum MeasurementId {
  IMPERIAL = 0, // inches, pounds
  METRICS = 1, // centimeters, kg
}

export const ReportTypes = ['Report a profile or content', 'Report a bug', 'Suggest feedback', 'Other'] as const
